export default {"src":"/_next/static/media/yardzen-approved.20d5bada.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};